export default __webpack_public_path__ + "assets/images/integrated-imageb40acc9b1d02384d94c5ddd3f20bcfc9.png";